import { stopPropagation } from "client/utils/stopPropagation";
import type { FontSources } from "store/features/memeGenerator/types/recentlyUsedFont";

interface FontProps {
    family: string;
    source: FontSources;
    handleClick: (family: string, source: FontSources) => void;
    close: () => void;
}

export const Font = ({ family, source, handleClick, close }: FontProps) => {
    return (
        <button
            style={{
                fontFamily: family,
                fontSize: `14px`,
                fontWeight: "400",
                lineHeight: "20px",
            }}
            className={`py-4 pl-4 whitespace-nowrap hover:bg-irGray-200 dark:hover:bg-darkSurface-300 text-left`}
            onClick={stopPropagation(() => {
                handleClick(family, source);
                close();
            })}
        >
            {family}
        </button>
    );
};
